<script setup>
//import { deviceStore } from './../../stores/deviceStore'

//const store = deviceStore();

defineProps({
    viewportID: {
      type: String,
      required: false
    },
    stream: {
      type: Object,
      default: {

      }
    },
    liveAudioStream: {
      type: Object,
      default: {

      }
    },
    liveVideoStream: {
      type: Object,
      default: {

      }
    },
    liveDataStream: {
      type: Object,
      default: {

      }
    },
    liveScreenStream: {
      type: Object,
      default: {

      }
    },
})

function minimizeLp(viewportID) {
    console.log("minimizeLp Clicked", viewportID, window.location.href);
    let viewPortElement = window.document.getElementById(viewportID);
    viewPortElement.style.height =  "100%";
    store.setLanding(false);
    store.addTerminationPoint({viewportID:viewportID, terminationID : window.LivingScript_0070.guid.generateSync(), MediaType : 'Iframe',URL:window.location.href});
  }
</script>

<script>
let GrantLeftID = '343432432';
export default {
  components: {
   },
  data: () => ({

        audioDivInitialized: false,
        screenLabel: 'Screen',
        boardLabel: 'Board',
        videoLabel: 'Video',
        audioLabel: 'Audio',
        textLabel: 'Chat',
        imgWidth: 40,
        imgHeight: 40,
        audioImgWidth: 22,
        audioImgHeight: 35,
        rowWidthMobileMode: 328,
        numberOfCells: 5,
        //mediaRow :  this.parentPanel.stateManager.state.sencondRow[this.dataRow.data.GrantLeftID],
        mediaRow : {"Audio" :{flag:true},"Video" :{flag:true},"Screen" :{flag:true},"Data" :{flag:true}},
        videoLocal: "videoLocal"+ GrantLeftID,
        videoRemote: "videoRemote"+ GrantLeftID,
        audioRemote: "audioRemote"+ GrantLeftID,
        screenRemote: "screenRemote"+ GrantLeftID,
        componentName: 'MediaPlayer',
        showText: false,
        textFontSize: 12,
        transitionActive: true,
        rowHeight :60,
        rowBGColor: 'lightgrey',
        iconColor: '#0072C5',
        lastChar: '',
        audioDivHeight: 40,
        audioDivWidth: 55,
        circles: [],
        screenTooltip : "Screen-share",
        textTooltip : "Chat",
        audioTooltip : "Audio",
        videoTooltip : "Video",
        whiteboardTooltip: "Whiteboard",
        textImgPath: `https://debianlargeserver-0050-kamalk-0054.laxroute53.com/simplia/dist/img/Group_2_js_pattern.png`,
        audioImgPath:`https://debianlargeserver-0050-kamalk-0054.laxroute53.com/simplia/dist/img/Mask_Group_3_jw_pattern.png`,
        videoImgPath:`https://debianlargeserver-0050-kamalk-0054.laxroute53.com/simplia/dist/img/Group_774_j_pattern.png`,
        whiteboardImgPath: `https://debianlargeserver-0050-kamalk-0054.laxroute53.com/simplia/dist/img/Group_776_kc_pattern.png`,
        screenImgPath:`https://debianlargeserver-0050-kamalk-0054.laxroute53.com/simplia/dist/img/Group_775_j_pattern.png`,
    }),
  mounted() {
  },
  computed : {
        /*
        lastChar() {
            return this.liveChat.message ? this.liveChat.message.charAt(this.liveChat.message.length - 1) : '';
        },*/
        liveChat() {
            //this.stateManager.state.sencondRow[dataRow.GrantID].chat.message = "new";
            return this.mediaRow.Chat;
        },
        liveAudio() {
            return this.mediaRow.Audio;
        },
        liveVideo() {
            return this.mediaRow.Video;
        },
        liveScreen() {
            return this.mediaRow.Screen;
        },
        liveData() {

            return this.mediaRow.Data;
        }
    },
    watch : {
    'mediaRow.Audio.flag': function(newVal) {
        if(newVal) {
            if(!this.audioDivInitialized) {
                this.initializeAudioDiv();
            }
        }
    },
    'liveChat.message' : function(newVal) {
        this.showText = (newVal !== null);
        this.transitionActive = false;
        this.$nextTick(function(){
            //setTimeout(()=>{
            this.textFontSize = 12;
            this.$nextTick(function(){
                this.lastChar = this.liveChat.message ? this.liveChat.message.charAt(this.liveChat.message.length - 1) : '';
                this.transitionActive = true;
                setTimeout(()=>{
                    this.textFontSize = 32;
                },300);
            });
            //},3000);
        });

    },
    'mediaRow.Chat': {
        handler(val) {
            this.parent.debugLog('watch-mediaRow.Chat data', 'mediaRow.Chat:', val);
        },
        deep: true
    }
},
  methods:{
    getMediaSelection() {
        console.log("Got media selection event");
    },
    showLiveStream() {
        console.log("Got live stream  event");
    },
    showFullscreen: function(viewPort) {
      let fullscreen = document.getElementById(viewPort);
        if (!document.fullscreenElement) {
          fullscreen?.requestFullscreen();
        } else {
          document.exitFullscreen();
        }
    },
    exitFullscreen: function(viewPort) {
      let fullscreen = document.getElementById(viewPort);
      document.exitFullscreen();
    },
    modalOpen() {
    },
    showRootMenu() {
    },
    openNav() {

    }
  }
}

</script>

<template v-if="stream.type == 'video' || stream.type == 'videoStream' || stream.type === 'audio' ">
<figure class="simplia-app" id="videoContainer">
	<div class="overlaycontent">
  	<div class="navbar">
    <template v-if="!showText">
    <span style="display: flex; justify-content: flex-start; align-items: stretch;height:40px;width:328px;">

        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-star;width: 325px;">
          <span @click="showLiveStream('media-event', stream,'chat',null)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
            <span style="color: rgb(0, 114, 197); width: 55px;height: 55px;" title="textTooltip"><img :width="imgWidth" :height="imgHeight" src="https://debianlargeserver-0050-kamalk-0054.laxroute53.com/simplia/dist/img/Group_2_js_pattern.png"></span>
        </span></span>
        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-start;width: 325px;">
            <span v-show="!mediaRow.Audio.flag" @click="showLiveStream('media-event', stream,'Audio',null)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
               <span style="color: rgb(0, 114, 197); width: 55px;height: 55px;" title="audioTooltip"><img :width="imgWidth" :height="imgHeight" :src="audioImgPath"></span>
            </span>
            <span v-show="mediaRow.Audio.flag"  @click="showLiveStream('media-event', stream,'Audio',liveAudio.stream)"
            style="width: 55px; cursor: pointer; display: flex; justify-content: flex-start; align-items: flex-start;flex-direction: column;">
                <span style="border: 1px solid red; color: red;" title="audioTooltip"><img :width="imgWidth" :height="imgHeight" :src="audioImgPath"></span><div ref="audioDiv"></div>
            </span>
        </span>
        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-start;width: 325px;">
            <span v-show="!mediaRow.Video.flag" @click="showLiveStream('media-event', stream,'Video', null)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
                <span style="color: rgb(0, 114, 197); width: 55px;height: 55px;" title="videoTooltip"><img  :width="imgWidth" :height="imgHeight" :src="videoImgPath"></span>
            </span>
            <span v-show="mediaRow.Video.flag"  @click="showLiveStream('media-event', stream,'Video',liveVideo.stream)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
                <video :id="videoLocal" class="zoom" autoplay width="45px" style="display: none; border: 1px solid red; "></video>
                <video title="videoTooltip" :id="videoRemote" class="zoom" autoplay width="45px" style=" border: 1px solid red; "></video>
            </span>
        </span>
        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-start;width: 328px">
            <span v-show="!mediaRow.Data.flag"  aria-hidden="true" @click="showLiveStream('media-event', stream,'Whiteboard', null)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
                <span style="color: rgb(0, 114, 197);  width: 55px;height: 55px;" title="Whiteboard"><img  :width="imgWidth" :height="imgHeight" :src="whiteboardImgPath"></span>
            </span>
            <span v-show="mediaRow.Data.flag"  aria-hidden="true" @click="showLiveStream('media-event',stream,'Whiteboard',liveData.stream)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
                <span style="color: red; height: 55px; width: 55px;" title="Whiteboard"><img :width="imgWidth" :height="imgHeight" :src="whiteboardImgPath"></span>
            </span>
        </span>
        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-start;width: 328px;">
            <span v-show="!mediaRow.Screen.flag" @click="showLiveStream('media-event',stream,'Screen',null)" style="cursor: pointer; display: flex; justify-content: center; align-items: center;">
                <span style="color: rgb(0, 114, 197); width: 55px;height: 55px" title="screen"><img  :width="imgWidth" :height="imgHeight" :src="screenImgPath"></span>
            </span>
            <span v-show="mediaRow.Screen.flag"  @click="showLiveStream('media-event',stream,'Screen',liveScreen.stream)" style="height: 55px; width: 55px; cursor: pointer; display: flex; justify-content: flex-start; flex-direction: column;">
                <video :id="screenRemote" class="zoom" autoplay width="45px" playsinline muted="muted"></video>
            </span>
        </span>
        </span>
        </template>
    <template v-else>
        <div>
        <div v-show="showText"  @click="showLiveStream('media-event', stream,'chat',null)"
         title="textTooltip"
        style="cursor: pointer; display: flex; justify-content: flex-start; align-items: flex-start; padding-left:12px; overflow-wrap: anywhere;width: 328px">
            {{liveChat.message}}
        </div>
        <span style="display: flex; justify-content: flex-start; align-items: stretch;height:60px;width:328px;">


        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-start;" :style="{width: cellWidth + 'px'}">
            <span v-show="!mediaRow.Audio.flag" @click="showLiveStream('media-event', stream,'Audio',null)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
               <span style="color: rgb(0, 114, 197); width: 55px;height: 55px; " title="Audio"><img :width="imgWidth" :height="imgHeight" :src="imgPath"></span>
            </span>
            <span v-show="mediaRow.Audio.flag"  @click="showLiveStream('media-event', stream,'Audio',liveAudio.stream)" style="width: 55px; cursor: pointer; display: flex; justify-content: center; align-items: flex-start;flex-direction: column;">
                <span style="color: red;border: 1px solid red;" title="Audio"><img :width="imgWidth" :height="imgHeight" :src="audioImgPath"></span><div ref="audioDiv"></div>
            </span>
        </span>
        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-start;width:325px;">
            <span v-show="!mediaRow.Video.flag" @click="showLiveStream('media-event', stream,'Video', null)" style="cursor: pointer; display: flex; justify-content: center; align-items: center;">
                <span style="color: rgb(0, 114, 197); width: 55px;height: 55px;" title="video"><img :width="imgWidth" :height="imgHeight" :src="videoImgPath"></span>
            </span>
            <span v-show="mediaRow.Video.flag"  @click="showLiveStream('media-event', stream,'Video',liveVideo.stream)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
                <video :id="videoLocal" class="zoom" autoplay width="45px" style=" display: none; border: 1px solid red; "></video>
                <video title="video" :id="videoRemote" class="zoom" autoplay width="45px" style=" border: 1px solid red; "></video>
            </span>
        </span>
        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-start;" :style="{width: cellWidth + 'px'}">
            <span v-show="!mediaRow.Data.flag"  aria-hidden="true" @click="showLiveStream('media-event', stream,'Whiteboard', null)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
                <span style="color: rgb(0, 114, 197); width: 55px;height: 55px;" title="whiteboard"><img :width="imgWidth" :height="imgHeight" :src="whiteboardImgPath"></span>
            </span>
            <span v-show="mediaRow.Data.flag"  aria-hidden="true" @click="showLiveStream('media-event',stream,'Whiteboard',liveData.stream)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
                <span style="color: red; height: 55px; width: 55px; " title="whiteboard"><img :width="imgWidth" :height="imgHeight" :src="whiteboardImgPath"></span>
            </span>
        </span>
        <span style="flex-grow: 1; display: flex; justify-content: center; align-items: flex-start;" :style="{width: cellWidth + 'px'}">
            <span v-show="!mediaRow.Screen.flag" @click="showLiveStream('media-event',stream,'Screen',null)" style="cursor: pointer; display: flex; justify-content: center; align-items: flex-start;">
                <span style="color: rgb(0, 114, 197); width: 55px;height: 55px;" title="screen" ><img  :width="imgWidth" :height="imgHeight" :src="screenImgPath"></span>
            </span>
            <span v-show="mediaRow.Screen.flag"  @click="showLiveStream('media-event',stream,'Screen',liveScreen.stream)" style="height: 55px; width: 55px; cursor: pointer; display: flex; justify-content: center; flex-direction: column;">
                <video  :id="screenRemote" class="zoom" autoplay width="45px" muted="muted"></video>
            </span>
        </span>
        </span>
        </div>
    </template>
    </div>
  		<div class="navbarRight"><button class="button button5">User1</button>&nbsp;<button class="button button5">User2</button>&nbsp;<button class="button button5">User3</button>&nbsp;<button class="button button5" @click="openNav" style="font-size:30px;cursor:pointer">&#9776; </button>&nbsp;</div>
  </div>
	<div id="myNav" class="overlay">
      <a href="javascript:void(0)" class="closebtn">&times;</a>
      <div class="overlay-content">
	       <span id="list" style="width: 380px; height: 340px; margin: 40px auto;"></span>
       </div>
  </div>

    <video v-if="stream.type == 'video'"
      id="myVideo"
      :ref="stream.streamID"
      :class="stream.streamID"
      :key="stream.streamID"
      :style="stream.style"
      :autoplay="stream.PlayerProp.autoplay"
      :muted="stream.PlayerProp.muted"
      :playsinline="stream.PlayerProp.playsinline"
      :src="stream.MediaSource"
      controls
      ></video>

	<ul id="video-controls" class="controls">
        <li><span id="stop" class="fa fa-phone" style="color:red;font-size:20px;"></span></li>
        <li><span id="playpause" class="fa fa-pause" style="font-size:20px"></span></li>
        <li><span id="mute" class="fa fa-minus-circle" style="font-size:20px"></span></li>
	</ul>
  <audio autoplay id="myAudio" style="display:none;"></audio>
</figure>
</template>

<style scoped>
@import '../../assets/mediacss/overlay.css';
@import '../../assets/mediacss/customcontrols.css';
@import '../../assets/mediacss/overlaySlide.css';
</style>
